//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
import BaoSearchDialog from "./../factories/bao-search-dialog";
import "./bao-auto-complete";
import "./bao-searcher-control";
import "./bao-selector";
import "./../components/base-config";
var bindingName = "baoSearcher";
function _defaults() {
    this.Enabled = ko.observable(true);
    this.AutoCompleteOpts = {};
    this.ObjectId = ko.observable();
    this.ObjectValue = ko.observable();
    this.ObjectKey = ko.observable("PrimaryKeyValue");
    this.SearchType = ko.observable();
    this.SelectedItem = ko.observable();
    this.MultiSelect = false;
    this.AutoComplete = ko.observable(false);
    this.GotoVisible = ko.observable(false);
    this.Goto = function () { };
    this.ValueDeleted = function () { };
    this.ValueChanged = function () { };
    this.CustomFilter = {};
    this.Items = ko.observableArray();
    this.BadgeText = ko.observable("Value");
    this.AutoSearch = false;
}
function _getApi(element) {
    return $(element).data(bindingName);
}
ko.bindingHandlers[bindingName] = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var api : any = {
            options: ko.createBindingConfig(valueAccessor(), new _defaults())
        };
        if (!ko.isObservable(api.options.Enabled)) {
            api.options.Enabled = ko.observable(api.options.Enabled);
        }
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            api = $(element).data(bindingName);
            if (api.Dialog != null) {
                api.Dialog.Destroy();
            }
            $(element).removeData(bindingName);
        });
        var open = ko.utils.unwrapObservable(valueAccessor().Open);
        var baseOpenFunction;
        if (open != null && typeof open === "string" && viewModel.hasOwnProperty(open) && typeof viewModel[open] === "function") {
            baseOpenFunction = viewModel[open];
            viewModel[open] = function () {
                _openSearchDialog(element, valueAccessor);
                if (baseOpenFunction != null && typeof baseOpenFunction === "function") {
                    baseOpenFunction();
                }
            };
        }
        $(element).data(bindingName, api);
        _initAutoComplete(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        _initSearcherControl(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        _initBaoSelector(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor) {
        var api = _getApi(element);
        var updatedOptions = ko.createBindingConfig(valueAccessor(), api.options);
        updatedOptions.Enabled = api.options.Enabled;
        api.options = updatedOptions;
        if (ko.unwrap(valueAccessor().Enabled) != null) {
            api.options.Enabled(ko.unwrap(valueAccessor().Enabled));
        }
    }
};
function _getCustomFilter(customFilter) {
    var iObject = 0;
    var customFilterHashObject = [];
    var keys = {};
    if (customFilter != null) {
        $.each(ko.utils.unwrapObservable(customFilter), function (key, value) {
            var hashObject : any = {};
            hashObject.Key = key;
            hashObject.Value = value;
            customFilterHashObject[iObject] = hashObject;
            iObject++;
            keys[key] = key;
        });
    }
    return ko.map.toJS(customFilterHashObject);
}
function _defaultsAutoComplete(element, options) {
    this.url = "Search/SearchAutoComplete";
    this.data = {
        searchKey: options.SearchType,
        searchString: "",
        customFilter: _getCustomFilter(options.CustomFilter)
    };
    this.textProperty = options.ObjectValue;
    this.idProperty = options.ObjectKey;
    this.requestProperty = "searchString";
    this.selectedItem = ko.observable({});
    this.preselect = false;
    this.enabled = options.Enabled;
    this.mousedown = ko.observable(false);
    this.canceled = ko.observable(false);
    this.forceSelection = true;
    this.delay = 300;
}
function _initSearcherControl(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
    var api = _getApi(element);
    var baoSearcherControlBinding : any = {
        searchFn: function () {
            _openSearchDialog(element, valueAccessor);
        },
        gotoFn: function () {
            var api = _getApi(element);
            if (typeof api.options.Goto === "function") {
                api.options.Goto();
            }
        },
        removeFn: function () {
            _deleteItem(element);
        },
        readonly: ko.computed(function () {
            var autoComplete = api.options.AutoComplete != null && ko.unwrap(api.options.AutoComplete) == true;
            return autoComplete == false || !ko.unwrap(api.options.Enabled);
        })
    };
    $.extend(baoSearcherControlBinding, valueAccessor());
    baoSearcherControlBinding.Enabled = api.options.Enabled;
    if (valueAccessor().GotoVisible != undefined) {
        baoSearcherControlBinding.GotoVisible = ko.computed(function () {
            if (ko.unwrap(valueAccessor().GotoVisible) && api.options.ObjectId() != null) {
                return true;
            }
            return false;
        });
    }
    ko.applyBindingsToNode(element, {
        baoSearcherControl: baoSearcherControlBinding
    }, bindingContext);
}
function _initAutoComplete(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
    var api = _getApi(element);
    if (api.options.AutoComplete != null && ko.utils.unwrapObservable(api.options.AutoComplete) == true) {
        var _foundItem = null;
        var _initText = $(element).val();
        var _changed = false;
        var options = ko.createBindingConfig(api.options.AutoCompleteOpts, new _defaultsAutoComplete(element, api.options));
        options.canceled.subscribe(function (canceled) {
            if (canceled == true) {
                options.selectedItem(null);
                $(element).val(_initText).change();
                _changed = false;
                options.canceled(false);
                $(element).parent().removeClass("has-warning").removeClass("has-success").removeClass("has-error");
            }
        });
        options.selectedItem.subscribe(function () {
            if (options.selectedItem() != null) {
                $(element).parent().removeClass("has-warning").removeClass("has-error").addClass("has-success");
            }
        });
        var baseSearching = options.searching;
        options.searching = function () {
            api = _getApi(element);
            options.data.customFilter = _getCustomFilter(api.options.CustomFilter);
            if (baseSearching != undefined) {
                baseSearching();
            }
        };
        var baseSearched = options.searched;
        var searchResult = [];
        options.searched = function (result, autocompletelist) {
            if (!ko.unwrap(api.options.MultiSelect)) {
                searchResult = autocompletelist;
                $(element).parent().removeClass("has-warning").removeClass("has-success").removeClass("has-error");
                if (searchResult.length == 1) {
                    $(element).parent().addClass("has-success");
                }
                else if (searchResult.length == 0) {
                    $(element).parent().addClass("has-error");
                }
                else if (searchResult.length > 1) {
                    var found = false;
                    for (var i = 0; i < searchResult.length; i++) {
                        if (searchResult[i].text != null && searchResult[i].text.toLowerCase() == ($(element).val() as string).toLowerCase()) {
                            $(element).parent().addClass("has-success");
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        $(element).parent().addClass("has-warning");
                    }
                }
                if (baseSearched != undefined) {
                    baseSearched(result, autocompletelist);
                }
            }
        };
        options.beforeSearch = function () {
            if (!ko.unwrap(api.options.MultiSelect)) {
                $(element).parent().removeClass("has-success").removeClass("has-error");
                $(element).parent().addClass("has-warning");
            }
        };
        options.validate = function () {
            if (ko.unwrap(api.options.Enabled)) {
                if (!ko.unwrap(api.options.MultiSelect)) {
                    if ($(element).val() != "") {
                        if (options.canceled() == false && searchResult.length == 1) {
                            options.selectedItem(searchResult[0]);
                        }
                        else if (options.canceled() == false && searchResult.length > 1) {
                            for (var i = 0; i < searchResult.length; i++) {
                                if (searchResult[i].text != null && searchResult[i].text.toLowerCase() == ($(element).val() as string).toLowerCase()) {
                                    options.selectedItem(searchResult[i]);
                                    break;
                                }
                            }
                        }
                        if (options.selectedItem() != null) {
                            _applyItem(element, options.selectedItem().data);
                        }
                        else {
                            if (options.forceSelection) {
                                _deleteItem(element);
                            }
                        }
                    }
                    else {
                        _deleteItem(element);
                    }
                    _initText = $(element).val();
                    $(element).parent().removeClass("has-warning").removeClass("has-success").removeClass("has-error");
                }
            }
        };
        options.MultiSelect = api.options.MultiSelect;
        if (allBindingsAccessor().textInput != undefined) {
            options.text = allBindingsAccessor().textInput;
        }
        else if (allBindingsAccessor().value != undefined) {
            options.text = allBindingsAccessor().value;
        }
        options.Items = api.options.Items;
        ko.applyBindingsToNode(element, {
            baoAutoComplete: options
        }, bindingContext);
    }
    else { }
}
function _baoSelectorCommit(element) {
    var selection = ko.observableArray([]);
    _itemsToSelection(element, selection);
    _applyItem(element, selection());
}
function _initBaoSelector(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
    var api = _getApi(element);
    var forceSelectionAutoComplete = ko.unwrap(api.options.AutoCompleteOpts.forceSelection);
    if (ko.unwrap(api.options.MultiSelect) && ko.unwrap(api.options.AutoComplete) && (forceSelectionAutoComplete == null || forceSelectionAutoComplete == true)) {
        var autoCompleteApi = $(element).data("baoAutoComplete");
        ko.applyBindingsToNode(element, {
            baoSelector: {
                Items: api.options.Items,
                mousedown: autoCompleteApi.ViewModel.options.mousedown,
                Committed: function () {
                    _baoSelectorCommit(element);
                }
            }
        }, bindingContext);
    }
}
function _itemsToSelection(element, selection) {
    var api = _getApi(element);
    var newSelection = [];
    if (api != null && api.options != null && api.options.Items != null) {
        ko.utils.arrayForEach(ko.unwrap(api.options.Items), function (item : any) {
            var newSelectionItem = {
                selected: ko.observable(true)
            };
            for (var key in item) {
                newSelectionItem[key] = item[key];
            }
            newSelectionItem[ko.unwrap(api.options.ObjectKey)] = ko.observable(ko.unwrap(item.Key));
            newSelectionItem[ko.unwrap(api.options.ObjectValue)] = ko.unwrap(item.Value);
            newSelection.push(newSelectionItem);
        });
    }
    selection(newSelection);
}
function _selectionToItems(element, selection) {
    var api = _getApi(element);
    var newItems = [];
    ko.utils.arrayForEach(selection(), function (item: any) {
        if (item.selected()) {
            var newItem = {
                Key: ko.unwrap(item[ko.unwrap(api.options.ObjectKey)]),
                Value: ko.unwrap(item[ko.unwrap(api.options.ObjectValue)]),
                removed: ko.observable(false)
            };
            newItems.push(newItem);
        }
    });
    api.options.Items(newItems);
}
function _openSearchDialog(element, valueAccessor) {
    var fn = valueAccessor().OpenDialog;
    if (fn != null && typeof fn === "function") {
        fn(element);
    }
    else {
        var baoSearchDialog = new BaoSearchDialog();
        var api = _getApi(element);
        api.options.ApplyItemCallback = function (searchViewModel) {
            if (ko.unwrap(api.options.MultiSelect)) {
                _selectionToItems(element, searchViewModel.Selection);
                _applyItem(element, searchViewModel.Selection());
            }
            else {
                _applyItem(element, searchViewModel.SelectedItem());
            }
        };
        baoSearchDialog.InitSearcher(api.options);
        _itemsToSelection(element, baoSearchDialog.ViewModel().Selection);
        api.Dialog = baoSearchDialog;
    }
}
function _deleteItem(element) {
    setTimeout(function () {
        var api = _getApi(element);
        $(element).val("");
        $(element).change();
        api.options.Items([]);
        if (api.options.ObjectId != null) {
            api.options.ObjectId(null);
        }
        if (api.options.ValueDeleted != null) {
            api.options.ValueDeleted();
        }
        api.options.SelectedItem(null);
    }, 1);
}
function _applyItem(element, selectedItem) {
    var api = _getApi(element);
    if (api != null) {
        var selectedText = null, selectedValue;
        var isMulti = ko.unwrap(api.options.MultiSelect) == true;
        if (isMulti) {
            selectedValue = [];
            ko.utils.arrayForEach(api.options.Items(), function (item: any) {
                var itemValue = ko.unwrap(item.Value);
                if (selectedText == null) {
                    selectedText = itemValue;
                }
                else {
                    selectedText = selectedText + ", " + itemValue;
                }
                selectedValue.push(ko.unwrap(item.Key));
            });
        }
        else {
            selectedText = ko.unwrap(selectedItem[ko.unwrap(api.options.ObjectValue)]);
            selectedValue = ko.unwrap(selectedItem[ko.unwrap(api.options.ObjectKey)]);
        }
        api.options.ObjectId(selectedValue);
        $(element).val(selectedText);
        $(element).change();
        if (api.options.SelectedItem != null && typeof api.options.SelectedItem === "function" && selectedItem != null) {
            if (isMulti) {
                api.options.SelectedItem(selectedItem);
            }
            else {
                api.options.SelectedItem(selectedItem);
            }
        }
        if (api.options.ValueChanged != null) {
            api.options.ValueChanged();
        }
    }
}